<template>
    <div class="container">
        <ak-modal
                :active="show"
                title="Modal title"
                width="1000px"
                @close="closeModal"
        >
            <iframe :src="'https://www.bookwidgets.com/lti/login?iss='+bwIssuerId" width="100%" height="600px" title="Sync exercises"></iframe>
        </ak-modal>
    </div>
</template>

<script>
    export default {
        name: 'Sync',
        data() {
            return {
                show: false,
                bwIssuerId: null,
            }
        },
        methods: {
            closeModal() {
                window.location = '/#/grid/exercise';
            }
        },
        created() {
            this.show = true;
            this.bwIssuerId = bwIssuerId;
        }
    }
</script>
